import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCommitments } from "../../../Services/journey";
import { useStandaloneHeader, JourneyBackHeader, JourneySubpageCard } from "../shared";
import { CommitmentRow, JourneySectionHead } from "../blocks";
import { COMMITMENT_COPY } from "../copy";
import "../style.css";

/**
 * All commitments (/journey/commitments — "See All" from the Journey home).
 * `GET /ARIS/v4/journey/commitments`, newest first, one page of 50.
 */
function Commitments() {
  const navigate = useNavigate();
  useStandaloneHeader();
  const [state, setState] = useState({ loading: true, items: [], error: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const payload = await getCommitments({ limit: 50 });
        if (!cancelled)
          setState({ loading: false, items: payload?.commitments || [], error: false });
      } catch (e) {
        console.error("Failed to load commitments", e);
        if (!cancelled) setState({ loading: false, items: [], error: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="journey-page">
      <div className="journey-page__inner">
        <JourneyBackHeader to="/journey" />
        <JourneySubpageCard>
          <JourneySectionHead title={COMMITMENT_COPY.listTitle} subtitle={COMMITMENT_COPY.listSubtitle} />
          {state.loading && <div className="journey-card journey-card--status">Loading…</div>}
          {!state.loading && state.error && (
            <div className="journey-card journey-card--status">{COMMITMENT_COPY.loadError}</div>
          )}
          {!state.loading && !state.error && state.items.length === 0 && (
            <div className="journey-card journey-card--status">{COMMITMENT_COPY.empty}</div>
          )}
          {state.items.length > 0 && (
            <div className="journey-rows">
              {state.items.map((c) => (
                <CommitmentRow
                  key={c.id}
                  commitment={c}
                  onOpen={() => navigate(`/journey/commitments/${encodeURIComponent(c.id)}`)}
                />
              ))}
            </div>
          )}
        </JourneySubpageCard>
      </div>
    </div>
  );
}

export default Commitments;
